import { defaultPage } from "@/assets/cannotAccessList";

const SET_DIALOG = 'SET_DIALOG';
const SHOW_DIALOG = 'SHOW_DIALOG';

export default {
   state: {
      title: "",
      message: "",
      isError: false,
      showDialog: false,
      returnLink: null,
      userType: '',
   },
   actions: {
      setDialogMessage: ({ commit }, { title, message, isError, returnLink, userType }) => {
         let _title = '';
         let msg = '';
         let error = false;
         let _link = null;

         if (message === 'noPermission') {
            if (userType !== undefined && userType !== null && userType !== '' && defaultPage[userType]) {
               _link = { path: defaultPage[userType] };
            } else {
               _link = { name: 'login' };
            }
         } else {
            _link = returnLink;
         }

         switch (message) {
            case 'noData':
               _title = 'Data not found';
               msg = 'Data not found. Please make sure the url is correct.';
               error = true;
               break;
            case 'noPermission':
               _title = 'No Permission';
               msg = 'You do not have permission to proceed the action';
               error = true;
               break;
            default:
               _title = title;
               msg = message;
               error = isError;
               break;
         }
         commit(SET_DIALOG, { 
            title: _title, 
            message: msg, 
            isError: error, 
            returnLink: _link 
         });
      },

      setShowDialog: ({ commit }, value) => {
         commit(SHOW_DIALOG, value);
      }
   },
   mutations: {
      [SET_DIALOG]: (state, { title, message, isError, returnLink }) => {
         state.title = title;
         state.message = message;
         state.isError = isError;
         state.returnLink = returnLink;
      },
      [SHOW_DIALOG]: (state, value) => {
         state.showDialog = value;
      },
   },
}
